import * as React from 'react';
import * as Modal from 'react-modal';
import { Button } from '@cian/ui-kit/button';
import * as styles from './index.css';
import { EntryField } from './EntryField';
import { IconClose } from '../popups/assets/icon_close';

export interface IDealRentEntryToShowModalProps {
  isOpen: boolean;
  isLoading: boolean;
  selectEntryToShow(date: string): void;
  close(): void;
}

export const DealRentEntryToShowModal = ({
  isLoading,
  selectEntryToShow,
  close,
  isOpen,
}: IDealRentEntryToShowModalProps) => {
  const [entry, setEntry] = React.useState('');

  const onSubmit = React.useCallback(() => {
    selectEntryToShow(entry);
  }, [selectEntryToShow, entry]);

  return (
    <Modal
      isOpen={isOpen}
      ariaHideApp={false}
      onRequestClose={close}
      style={{
        content: {
          overflow: 'visible',
          padding: '20px',
          position: 'static',
          width: '300px',
          zIndex: 101,
        },
        overlay: {
          alignItems: 'center',
          backgroundColor: 'rgba(24, 41, 48, 0.8)',
          display: 'flex',
          justifyContent: 'center',
          zIndex: 100,
        },
      }}
    >
      <div className={styles['container']}>
        <div className={styles['header']}>
          <h2 className={styles['title']}>Запись на показ</h2>
          <button className={styles['close']} onClick={close}>
            <IconClose />
          </button>
        </div>
        <div className={styles['info']}>Выберите удобное время для записи</div>
        <EntryField entry={entry} setEntry={setEntry} />
        <div className={styles['button']}>
          <Button loading={isLoading} size="XS" onClick={onSubmit}>
            Записаться
          </Button>
        </div>
      </div>
    </Modal>
  );
};
